import { Typography } from '@mui/material';
import { FinanceProgram, FinanceProgramInsuranceCoverage } from '@trnsact/trnsact-shared-types';


export const InsuranceCoverageRequirements = ({
  financeProgram,
  commonClasses
}: {
  financeProgram?: FinanceProgram,
  commonClasses: any,
}) => {


  if (!financeProgram?.insuranceCoverage) {
    return null;
  }

  const insuranceCoverageKeys = Object.keys(financeProgram.insuranceCoverage).filter(k => k !== '__typename') as (keyof FinanceProgramInsuranceCoverage)[];

  return <>
    <Typography variant='h5' className={commonClasses.subHeader}>Insurance Coverage Requirements</Typography>
    {insuranceCoverageKeys.map(key => <div key={key} dangerouslySetInnerHTML={{ __html: financeProgram.insuranceCoverage![key]! }}></div>)}
  </>
};
